import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { SaleOrderService } from '../../../services/sale-order.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
    selector: 'so-outbound-errors',
    templateUrl: './so-outbound-errors.component.html',
    styleUrls: ['./so-outbound-errors.component.scss']
})
export class SOOutboundErrorsComponent implements OnInit, OnChanges {

    @Input() saleOrderId: number;

    showLoader: boolean = false;

    displayedColumns: string[] = [
        'time',
        'reason',
    ];
    dataSource = [];

    constructor(
        private saleOrderService: SaleOrderService,
        private notifySvc: NotificationService,
        private userService: UserService,
    ) {
    }

    ngOnInit(): void {
        if (this.userService.isAdmin) {
            this.displayedColumns.push('actions');
        }
        this.getLogs();
    }

    getLogs(): void {
        this.showLoader = true;
        this.saleOrderService.getOutboundLogs(this.saleOrderId).subscribe(res => {
            this.dataSource = res;
            this.showLoader = false;
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
    }

    createMovement(id: number): void {
        this.saleOrderService.createMovementByAuditLog(+id).subscribe(res => {
            if (!res.success) {
                this.notifySvc.showError(res.message);
            } else {
                this.getLogs();
                this.notifySvc.showSuccessMessage('Created successfully');
            }
        });
    }
}
